// src/constants/sectionData.ts
export const sections = [
    'Culture',
    'Recruitment & Selection',
    'Rewards & Recognition',
    // 'Organization Effectiveness',
    'Learning & Development',
    'Work Environment & Engagement',
    'Talent & Growth',
    'People Data & Analytics',
];
 
export const sectionPaths: { [key: string]: string } = {
    'Culture': '/operations/people/culture',
    'Recruitment & Selection': '/operations/people/recruitment-selection',
    'Rewards & Recognition': '/operations/people/rewards-recognition',
    // 'Organization Effectiveness':  '/operations/people/organization-effectiveness/manager',
    'Learning & Development':  '/operations/people/learning-development',
    'Work Environment & Engagement':  '/operations/people/work-environment-engagement',
    'Talent & Growth':  '/operations/people/talent-growth',
    'People Data & Analytics':  '/operations/people/people-data-analytics',
};